const setFilters = (state, action) => action.filters || state;

export default setFilters;
